
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralSouth as ObiBeaconGeneralSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-south.js';
 
 
 

 
 export const ObiBeaconGeneralSouth = createComponent({
   react: React,
   tagName: 'obi-beacon-general-south',
   elementClass: ObiBeaconGeneralSouthElement,
   events: {
     
   }
  });
 
 